/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerWarnings
 */
export interface SearchEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: SearchEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: SearchEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: SearchEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: SearchEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const SearchEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof SearchEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof SearchEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const SearchEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerWarningsColorGradationEnum = typeof SearchEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof SearchEvidences200ResponseInnerWarningsColorGradationEnum];
export const SearchEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWarningsHeightMillisEnum = typeof SearchEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof SearchEvidences200ResponseInnerWarningsHeightMillisEnum];
export const SearchEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWarningsWidthMillisEnum = typeof SearchEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof SearchEvidences200ResponseInnerWarningsWidthMillisEnum];


